import { message } from 'antd';


export default function MessageAlert(text:string){
  message.success(text)
}